import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateFn, UrlTree, Router } from "@angular/router";
import { Observable, firstValueFrom } from "rxjs";
import { MsalGuard } from "@azure/msal-angular";
import { GenesysLoginService } from "./gensys-auth.guard";

@Injectable({
  providedIn: 'root'
})
export class SequentialGuardService {

  constructor(private msalGuard: MsalGuard, private genesysLoginService: GenesysLoginService, private router: Router) {}

  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    let azureLogin = await firstValueFrom(this.msalGuard.canActivate(next, state));
    let genesysLogin = await this.genesysLoginService.canActivate(next,state)
    return azureLogin&& genesysLogin
  }
}

export const SequentialGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
  return inject(SequentialGuardService).canActivate(next, state);
}
